export interface PageMetaDto {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
}

export class SweetFacePagedResponse<T> {
  data: T[];
  meta: PageMetaDto;
}
